import { translate as mainTranslate } from 'loankeeper-common/helpers'

export const translate = (key) => mainTranslate(`frm_lfl_file_add_edit-${key}`)
export const translateWebMessages = (name) => mainTranslate(`frm_web_messages-${name}`)
export const translateLKMessage = (name) => mainTranslate(`LKMESSAGE-${name}`)
